import { useTheme } from "../context/ThemeContext";

const problems = [
  { title: "Long content cycles.", detail: "Months to update. Passengers see stale libraries." },
  { title: "Expensive supply chain.", detail: "High cost per title. Vendors stacked on vendors." },
  { title: "Fragmented delivery.", detail: "Studios, encoders, QC and OEMs complexity." },
];

const SlideMarketReality = () => {
  const { isDark } = useTheme();
  return (
    <div>
      <div className="k-eyebrow" style={{ color: isDark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.5)" }}>
        The problem
      </div>
      <h2 className={`k-h2 mt-3 max-w-[16ch] ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
        IFE has a passenger
        <br />
        <span style={{ color: "var(--k-accent)" }}>engagement problem.</span>
      </h2>
      <p className={`k-lead mt-6 max-w-[54ch] ${isDark ? "text-white/70" : "text-black/60"}`}>
        Airlines invest heavily in hardware and content — yet passengers
        still don't feel seen. The gap is not the seat-back. It's the
        supply chain behind it.
      </p>

      <ol className={`mt-14 grid grid-cols-3 gap-10 pt-8 border-t ${isDark ? "border-white/10" : "border-black/10"}`}>
        {problems.map((p, i) => (
          <li key={p.title}>
            <div className="k-eyebrow" style={{ color: isDark ? "rgba(255,255,255,0.35)" : "rgba(0,0,0,0.35)" }}>
              0{i + 1}
            </div>
            <div className={`mt-3 text-[22px] font-semibold tracking-tight ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
              {p.title}
            </div>
            <p className={`mt-2 text-[15px] leading-relaxed ${isDark ? "text-white/60" : "text-black/55"}`}>
              {p.detail}
            </p>
          </li>
        ))}
      </ol>

      <div
        className="mt-8 rounded-2xl px-8 py-8 border"
        style={{
          borderColor: isDark ? "rgba(242,169,0,0.35)" : "rgba(242,169,0,0.35)",
          backgroundColor: isDark ? "rgba(242,169,0,0.06)" : "rgba(242,169,0,0.08)",
        }}
      >
        <div className="k-eyebrow" style={{ color: "var(--k-accent)" }}>The real problem</div>
        <div className={`mt-2 text-[26px] font-semibold tracking-tight ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
          Knowing the passenger — and engaging with them.
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          {["Satisfaction", "Loyalty", "Monetisation", "Personalisation", "Data connectivity", "Real-time engagement"].map((t) => (
            <span key={t} className="text-[12px] font-medium px-3 py-1 rounded-full" style={{ backgroundColor: "rgba(242,169,0,0.18)", color: "var(--k-accent-strong)" }}>
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SlideMarketReality;
